import React, { Component } from 'react';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';

export class Docs extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = 'Docs'
    this.quizId = this.props.match.params.quizId
    this.groupId = 'doc'
    this.noAdd = true
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['items'], { pb: 'fieldDef', groupId: this.groupId }) },
    ]
    this.tableHeadersMap = {
      Id: (current) => current.itemId,
      Document: (current) => current.docName ? 'YES' : 'NO',
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.groupId,
    }
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Docs' },
    ]
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef;
    this.setState({
      items: Helper.sortDictArray(results[0].items),
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['items'], { groupId: this.groupId }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/Docs.js